import { render, staticRenderFns } from "./atb.vue?vue&type=template&id=3e4bcadd&scoped=true"
import script from "./atb.vue?vue&type=script&lang=js"
export * from "./atb.vue?vue&type=script&lang=js"
import style0 from "./atb.vue?vue&type=style&index=0&id=3e4bcadd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4bcadd",
  null
  
)

export default component.exports